<template>
  <div class="phonebg">
    <div class="jiudian">
      <div class="title">星云</div>
    </div>
    <div class="message" v-if="message != null && message != ''" v-html="message"></div>
    <div class="tuchu">
      <img src="../../assets/baseimg/bwyewm.jpg" alt  />
      <div>长按识别图中二维码，了解更多酒店功能！</div>
      <div>全球鹰3、手机客房中心、微信订房，等...</div>
    </div>
   
  </div>
</template>

<script>
import { postRequest } from "@/api/api1.js";

export default {
  name: "welcome",
  data() {
    return {
      message:null,
    };
  },
  created() {
    this.message =   this.$route.query.message;
  },
  mounted() {},
  methods: {
    
  }
};
</script>
<style scoped>

.phonebg{
  background:linear-gradient(0deg, #D6EBFF 0%, #E9F4FF 48%, #D6EBFF 100%);
/* background: linear-gradient(180deg, #D6EBFF, #E9F4FF 48%, #D6EBFF); */
}
.jiudian{
 box-shadow: 8px 8px 20px #b9ccec, -8px -8px 15px #ffffff;
}
.title{
  text-align:center;
  font-weight: bold;
  font-size: 1.2rem;
  height: 3rem;
  line-height: 3rem;
}
.tuchu{
    box-shadow: 8px 8px 20px #b9ccec, -8px -8px 15px #ffffff;
    position: fixed;
    width: 20rem;
    height: 25rem;
    transform: translate(-50%, -50%);
    left: 50%;
    top: 46%;
}
.tuchu img{
  width: 80%;
  margin:10% 10% 5% 10%;
}
.tuchu div{
  text-align: center;
  font-size: 1rem;
  line-height: 2rem;
}
.message{
  width: 94%;
  line-height: 2rem;
  text-align: center;
  color: red;
  margin-top: 1rem;
  font-weight: bold;
  margin:1rem 2% 0rem 2%;
}
</style>